import { Injectable } from '@angular/core';

import { IBetslipState } from '../../../../../base/store/state';
import { IFullBetslip } from '../../../../bet-generation/models';
import { BetslipError } from '../../../errors/betslip-error';
import { BetslipValidationComposerService } from './betslip-validation-composer.service';

@Injectable()
export class BetslipValidationService {
    constructor(private betslipValidationComposer: BetslipValidationComposerService) {}

    validate(fullBetslip: IFullBetslip, state: IBetslipState): BetslipError[] {
        const slips = Object.values(fullBetslip.typeBetslips).flatMap((betslip) => betslip.slips);

        return this.betslipValidationComposer.validateBetslip({ slips }, state);
    }
}
